import { isObject } from 'lodash'
import { sniff } from '@/util'
import queryString from 'query-string'
import Env from '@/Api/domain'

enum shareType {
  ipMachineMinprogram = 'ipMachineMinprogram',
  web = 'web',
  uboxApp = 'uboxApp',
  onlyMinprogram = 'onlyMinprogram',
}

export type shareConfigProps = {
  title?: string // 分享三要素-标题
  description?: string  // 分享三要素-副标题
  image?: string  // 分享三要素-图片地址
  url: string // 分享三要素-跳转地址
  show_long_image?: boolean // 是否显示分享组件中的长图按钮
  download_image_url?: string // 长图地址，传递图片则直接显示图片而不是截屏
  type?: shareType // 分享类型 minprogram： 小程序卡片; web: 网页；uboxApp： fansmll App; onlyMinprogram:  微信直接分享
  username?: string // 分享类型是 minprogram 时，要传入username
  path?: string // 跳转小程序卡片路径。
}

export const fixedUrl = (url: string): string => {
  const isHttpUrl = /^http[s]?:/.test(url)
  if ( !isHttpUrl ) return 'https://m.ubox.com'
  // 合并拆解出的path和参数出一个新的url
  try {
    // 如果是生产则直接返回
    if ( Env.getEnv() === 'prod' ) return url
    const parsedUrl = queryString.parseUrl(url)
    // 拆解出path和参数
    const sourceQuery = parsedUrl.query
    const sourceUrl = parsedUrl.url
    // 合并拆解出的path和参数出一个新的url
    const assignQuery: any = { ...sourceQuery, subenv: Env.getEnv() }
    // 删除历史遗留问题 url中的环境变量拼写错误
    assignQuery.subevn && delete assignQuery['subevn']
    return queryString.stringifyUrl({
      url: sourceUrl,
      query: assignQuery,
    })
  } catch (error) {
    return url
  }
}

const shareConfig = function (config: shareConfigProps): void {
  // 非对象并且不是空字符串时，直接返回
  if ( !isObject(config) && !(config?.url || config?.path) ) return
  const isHttpUrl = /^http[s]?:/.test(config?.url)

  // 测试环境subenv处理
  config.url = fixedUrl(config?.url)

  // 如果传入ytpe，则前端设置 唯一id
  if(config.type === 'ipMachineMinprogram' || config.type === 'onlyMinprogram') {
    config.username = 'gh_cd8a0ab4f404'  // 抽卡小程序唯一id
  }

  // 设置跳转地址
  if ( isHttpUrl && config.username && !config.path ) {
    config.path = `/pages/web-view-custom/web-view-custom?url=${encodeURIComponent(config?.url)}`
  }

  config.image = config?.image || 'https://cdn.shubox.com/ubox-fe/images/logo/logo132x132.png'
  let jsonStr = ''
  try {
    jsonStr = JSON.stringify(config)
  } catch (error) {
    jsonStr = ''
  }

  if (sniff.isUboxAndroidApp) {
    window.app?.shareConfig && window.app?.shareConfig(jsonStr)
  } else if (sniff.isUboxIosApp) {
    window?.webkit?.messageHandlers?.shareConfig && window?.webkit?.messageHandlers?.shareConfig.postMessage(jsonStr)
  } else if ( sniff.isWechatMiniProgram ) {
    window.wx.miniProgram.postMessage({ data: config })
  }
}

export default shareConfig